export enum TriggerLocation {
  BOARD_GROUP = 'BOARD_GROUP',
  NAV = 'NAV',
  VIEW = 'VIEW',
  CONTEXTUALIZATION = 'CONTEXTUALIZATION',
  UNI = 'UNI',
  UPDATE = 'UPDATE',
  SETUP_RELATIONSHIP = 'SETUP_RELATIONSHIP',
  SLIDE_OUT = 'SLIDE_OUT',
  GRID_EDIT_MODE = 'GRID_EDIT_MODE'
}
